import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";

import { palette } from "../../../theme/palette";

import {
  setAddRouteModalOpen,
  setSelectedRoute,
} from "../../../reducers/ownApp";
import { getSelectedDepot } from "../../../reducers/ownApp/selectors";
import { routeEditModeSelector } from "../../../reducers/routeManagement/selectors";

import DepotSummary from "../../DepotSummary";
import LockComponent from "./LockComponent";
import { View } from "../../View";
import { ActionButton } from "../Common/ActionButton";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    height: typography.pxToRem(30),
    width: "100vw",
    backgroundColor: palette.transparent,
  },
  rightActions: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
  },
  leftContent: {
    display: "inline-block",
  },
}));

export const Subheader = () => {
  const dispatch = useDispatch();
  const selectedDepot = useSelector(getSelectedDepot);
  const routeEditMode = useSelector(routeEditModeSelector);
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <View className={styles.leftContent}>
        <DepotSummary />
      </View>
      <View className={styles.rightActions}>
        <View>
          {selectedDepot && (
            <ActionButton
              variant={"yellow"}
              disabled={routeEditMode}
              onClick={() => {
                dispatch(setAddRouteModalOpen(true));
                dispatch(setSelectedRoute(null));
              }}
            >
              + Add New Route
            </ActionButton>
          )}
        </View>
        <LockComponent />
      </View>
    </View>
  );
};
